/** Central URLs + styles for Terms / Privacy / Support links (dashboard, auth, signup). */

export const MF_TERMS_URL = "https://www.magicfurnish.com/terms-and-conditions";
export const MF_PRIVACY_URL = "https://www.magicfurnish.com/privacy-policy";
/** Matches `Layout.js` support entry point. */
export const MF_SUPPORT_URL = "https://www.magicfurnish.com/support";

/**
 * Single source of truth is package.json's "version". The build/start/test
 * scripts pipe it in as REACT_APP_VERSION (=$npm_package_version), which CRA
 * inlines at build time. Bump package.json once and the footer follows.
 */
export const APP_VERSION = `v${process.env.REACT_APP_VERSION || ""}`;

/** Shared MUI `sx` for inline legal links (11px tertiary, underline on hover). */
export const legalLinkSx = {
  color: "var(--color-text-tertiary)",
  fontSize: "11px",
  textDecoration: "none",
  "&:hover": { textDecoration: "underline" },
};

/** Same type scale as `legalLinkSx` for non-link text in the strip (e.g. version). */
export const legalVersionLabelSx = {
  ...legalLinkSx,
  fontSize: "10px !important",
  cursor: "default",
  textDecoration: "none",
  "&:hover": { textDecoration: "none" },
};
